<script>
import { progressnotesMetaFields as metaFields } from "./metaFields";
import { Validator } from "@/plugins/validator";
export default {
    name: "UploadMedicalFiles",

    data() {

        return {
            document: {
                name: `Progress Notes`,
                doctor: ``,
                doctorId:0,
                date: window.moment().format(`YYYY-MM-DD`),
               
            },
            errors: [],
            
        };
    },

    props: {
        showModal: Boolean,
        
        doctorsnnurses: {
            type: Array,
            required: true,
        },
        progressnote: {
            type: Object,
            required: true,
        },
    },
   watch:{
    'document.doctorId'() {
            if(!this.document.doctorId) {
                this.document.doctor = ``;
                return;
            }

            this.doctorsnnurses.forEach(dep => {
                if(dep.id == this.document.doctorId) {
                    this.document.doctor = dep.names;
                }
            });
        },
   },
    methods: {
        saveUploadFile() {
      new Validator(this.document, metaFields)
        .validate()
        .then(() => {
            this.$root.loading = true;
          let url = `Files/PostProgressNotesDocument`;
              url += `?ID=${0}`;
              url += `&EncouterID=${this.progressnote.encounterId}`;
              url += `&PatientID=${this.progressnote.patientID}`;
              url += `&VisitNo=${this.progressnote.visitNo}`;
              url += `&DocName=${this.document.name}`;
              url += `&contentType=${this.$refs.file.files[0].type}`;
              url += `&UserName=${this.$root.username}`;
              url += `&ProgressNotes=${this.progressnote.progressNotes}`;
              url += `&DoctorId=${this.document.doctorId}`;
              url += `&Doctor=${this.document.doctor}`;
              url += `&EntryDate=${this.document.date}`;
              
          const file = this.$refs.file.files[0];
          const formData = new FormData();
          formData.append('file', file);
          this.$http.post(url, formData).then(({ data }) => {
              this.$emit(`refresh`);
              this.$refs.file.value = null;
              this.document = {
                  name: ``,
              };
              this.$root.loading = false;
              this.$emit(`closeModal`);
              window.Swal.fire({ type: `success`, text: data, })
          }).catch(() => { this.$root.loading = false; })
        })
        .catch((errors) => {
          this.errors = errors;
        });
    },
      saveUploadFile1() {
          this.$root.loading = true;
          let url = `Files/PostProgressNotesDocument`;
              url += `?ID=${0}`;
              url += `&EncouterID=${this.progressnote.encounterId}`;
              url += `&PatientID=${this.progressnote.patientID}`;
              url += `&VisitNo=${this.progressnote.visitNo}`;
              url += `&DocName=${this.document.name}`;
              url += `&contentType=${this.$refs.file.files[0].type}`;
              url += `&UserName=${this.$root.username}`;
              url += `&ProgressNotes=${this.progressnote.progressNotes}`;
              url += `&DoctorId=${this.document.doctorId}`;
              url += `&Doctor=${this.document.doctor}`;
              url += `&EntryDate=${this.document.date}`;
              
          const file = this.$refs.file.files[0];
          const formData = new FormData();
          formData.append('file', file);
          this.$http.post(url, formData).then(({ data }) => {
              this.$emit(`refresh`);
              this.$refs.file.value = null;
              this.document = {
                  name: ``,
                  date: window.moment().format(`YYYY-MM-DD`),
              };
              this.$root.loading = false;
              this.$emit(`closeModal`);
              window.Swal.fire({ type: `success`, text: data, })
          }).catch(() => { this.$root.loading = false; })
      },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-2/3 w-3/4 overflow-auto">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Upload File</h5>
  </template>
  <template v-slot:modal-body>
    <form id="file-upload-form" 
        @submit.prevent="saveUploadFile" 
        class="content-start w-full flex flex-wrap h-40">
        <!-- <div class="w-1/3 p-1">
            <label for="grid-document-name" class="label-control">Progress Name:</label> 
            <input type="text"
                required 
                id="grid-document-name" 
                v-model.trim="document.name" 
                class="input-control input-sm text-xs">
        </div> -->
        <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-date-from" class="label-control">Date:</label> 
                  <input type="date" id="grid-date-from" 
                    v-model.trim="document.date" class="input-control input-sm text-xs">
              </div>
         <div class="md:w-1/3 sm:w-full p-tiny">
                          <label for="grid-doctor" class="label-control">Doctor:</label> 
                          <v-select
                             :options="doctorsnnurses"
                             v-model="document.doctorId" 
                             class="bg-white text-xs" label="names" 
                             :reduce="doctor => doctor.id">
                             required
                          </v-select>
                          <p class="form-text-error" 
                            v-if="errors.filter(error => error.field == 'doctorId').length">
                                {{ errors.filter(error => error.field == 'doctorId')[0].message }}</p>
                      </div>
        <div class="w-1/3 p-1">
            <label for="grid-file" class="label-control">File:</label>
            <input type="file"
                required
                id="grid-file" 
                ref="file" 
                class="input-control input-sm text-xs">
        </div>
    </form>
  </template>
  <template v-slot:modal-footer>
    <button 
        class="btn-danger btn-sm text-xs rounded mr-6" 
        @click.prevent="$emit(`closeModal`)">
        <i class="fa fa-times"></i> Close</button>
    <button 
        form="file-upload-form"
        type="submit"
        class="btn-primary btn-sm text-xs rounded">
        <i class="fa fa-save"></i> Save</button>
  </template>
</tail-modal>
</template>
